<template>
<a-row>
  <a-row>
    <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: right">
      <a-rate allowHalf style="color: red" v-model="item.profile.like" @change="following">
        <a-icon slot="character" type="heart" style="font-size: 16px"/>
      </a-rate>
      <a @click="showComments($event)" style="margin-left: 8px">
        <a-icon type="edit" style="font-size: 16px"/>
      </a>
    </a-col>
  </a-row>
  <a-row class="comment-panel" style="display: block" v-if="item.showComments">
      <a-col :span="24">     
        <Record @additem="addItem" :Ent_tag="tag" style=" margin-bottom: 0px; margin-top: 0px; "/>
      </a-col>

      <a-col :span="24" v-if="item.profile">
        <a-row v-for="coms, order in item.profile.comments" :key="order">
          <p>
            <Record @deleteitem="deleteItem" @topitem="topItem" @resetitem="resetItem" :item="coms.content" :order="order" :time="coms.time " :top="coms.top"  :Ent_tag="tag" style=" margin-bottom: 0px; margin-top: 0px; "/>
          </p>
        </a-row>
      </a-col>
  </a-row>
  <a-row class="comment-panel" style="display: none" v-else="">
      <a-col :span="24">     
        <Record @additem="addItem"  :Ent_tag="tag" style=" margin-bottom: 0px; margin-top: 0px; "/>
      </a-col>
      <a-col :span="24" v-if="item.profile">
        <a-row v-for="coms, order in item.profile.comments" :key="order">
          <p>
            <Record @deleteitem="deleteItem" @topitem="topItem" @resetitem="resetItem" :item="coms.content" :order="order" :time="coms.time " :top="coms.top" :Ent_tag="tag" style=" margin-bottom: 0px; margin-top: 0px; "/>
          </p>
        </a-row>
      </a-col>
  </a-row>
</a-row>
</template>

<script>

import Record from './Record.vue'

export default {
  name: 'Comments',
  props: {
    Ent_tag: {
      type: Number,
      default: function() {
        return 0
      }
    },
    item: Object,
    default: function() {
      return {}
    },
    index: Number,
    default: function() {
      return 0
    }
  },

  data() {
    return {
      tag: this.Ent_tag
    }
  },
  components: {
    Record,
  },
  methods: {

    topItem: function(order) {
      this.$emit('topitem', order);
    },
    resetItem: function(order) {
      this.$emit('resetitem', order);
    },
    following: function(value) {
      this.$emit('following', this.item, value);
    },

    deleteItem: function(order) {
      this.$emit('deleteitem', this.item, order);
    },

    addItem: function(comment) {
      this.$emit('additem', comment, this.item);
    },

    showComments: function(e) {
      let elem = e.target.localName;
      if (elem == "svg") {
        let display = e.target.parentNode.parentNode.parentNode.parentNode.parentNode.lastChild.style.display;
        if (display == "none") {
          e.target.parentNode.parentNode.parentNode.parentNode.parentNode.lastChild.style.display = "block";
          this.item["showComments"] = true;
        } else {
          e.target.parentNode.parentNode.parentNode.parentNode.parentNode.lastChild.style.display = "none";
          this.item["showComments"] = false;
        }
      } else {
        let display = e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.lastChild.style.display;
        if (display == "none") {
          e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.lastChild.style.display = "block";
          this.item["showComments"] = true;
        } else {
          e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.lastChild.style.display = "none"
          this.item["showComments"] = false;
        }
      }
    }
  }
}
</script>

<style>
    .comment-panel {
        margin-top: 8px;
        margin-bottom: 4px;
    }
</style>
